import {
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { DEFAULT_TITLE_OPTS, titleWithNameUI } from '../../../../definitions';
import content from '../../../../locales/en/content.json';
import { strWithYear } from '../../../../utils/helpers';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['dependent-info--addtl-title'];
const INPUT_LABELS = {
  disabled: content['dependent-info--addtl-disabled-label'],
  cohabited: strWithYear(content['dependent-info--addtl-cohabited-label']),
  income: strWithYear(content['dependent-info--addtl-income-label']),
};

const { disabledBefore18, cohabitedLastYear } =
  FULL_SCHEMA.properties.dependents.items.properties;

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.dependents),
    disabledBefore18: yesNoUI(INPUT_LABELS.disabled),
    cohabitedLastYear: yesNoUI(INPUT_LABELS.cohabited),
    'view:dependentIncome': yesNoUI(INPUT_LABELS.income),
  },
  schema: {
    type: 'object',
    required: ['disabledBefore18', 'cohabitedLastYear', 'view:dependentIncome'],
    properties: {
      disabledBefore18,
      cohabitedLastYear,
      'view:dependentIncome': yesNoSchema,
    },
  },
};
